import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend
} from 'recharts';
import { getChartSeriesColor } from '../../../utils/chartUtils';

export const renderPieChart = (chartData, theme) => {
  const { labels, datasets, options = {}, title } = chartData;

  // Transform data for recharts pie chart format
  // For pie charts, we typically use the first dataset
  const primaryDataset = datasets[0] || { data: [], label: 'Data' };
  const transformedData = labels.map((label, index) => ({
    name: label,
    value: primaryDataset.data[index] || 0,
  }));

  // Generate colors for pie segments
  const getSegmentColors = () => {
    return transformedData.map((_, index) => getChartSeriesColor(index, theme.isDark));
  };

  const segmentColors = getSegmentColors();

  // Custom label function for pie segments
  const renderCustomLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }) => {
    if (percent < 0.05) return null; // Don't show labels for segments less than 5%
    
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-midAngle * RADIAN);
    const y = cy + radius * Math.sin(-midAngle * RADIAN);

    return (
      <text 
        x={x} 
        y={y} 
        fill={theme.colors.cardBackground || '#ffffff'}
        textAnchor={x > cx ? 'start' : 'end'} 
        dominantBaseline="central"
        fontSize="12"
        fontWeight="600"
      >
        {`${(percent * 100).toFixed(0)}%`}
      </text>
    );
  };

  return (
    <div className="w-full">
      {title && (
        <h3 
          className="mb-3 text-[15px] font-semibold"
          style={{ color: theme.colors.text }}
        >
          {title}
        </h3>
      )}
      
      <div className="w-full h-80">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={transformedData}
              cx="50%"
              cy="50%"
              labelLine={false}
              label={options.showLabels !== false ? renderCustomLabel : false}
              outerRadius={80}
              fill="#8884d8"
              dataKey="value"
            >
              {transformedData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={segmentColors[index]} />
              ))}
            </Pie>
            <Tooltip
              contentStyle={{
                backgroundColor: theme.colors.surfaceElevated || theme.colors.cardBackground,
                border: `1px solid ${theme.colors.cardBorder}`,
                borderRadius: '6px',
                color: theme.colors.text,
                fontSize: '12px'
              }}
              labelStyle={{
                color: theme.colors.text,
                fontWeight: '600'
              }}
              formatter={(value, name) => [value, name]}
            />
            <Legend
              wrapperStyle={{
                color: theme.colors.text,
                fontSize: '12px'
              }}
              iconType="circle"
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}; 